export { default } from './SimpleTable';
export { simpleTablePropTypes } from './SimpleTable.constants';
